export default "__VITE_ASSET__DKw2rxiS__"